export const dataTable = {
  all: 'Todos',
  applyFilters: 'Aplicar filtros',
  clear: 'Limpiar',
  clearAll: 'Limpiar todo',
  columns: 'Columnas',
  elements: 'elementos',
  errorDescription: 'Error al cargar los datos de la tabla. Intente nuevamente.',
  filters: 'Filtros',
  from: 'Desde',
  fromGreaterThanTo: 'La fecha desde no puede ser mayor que la fecha hasta',
  goToFirstPage: 'Ir a la primera página',
  goToLastPage: 'Ir a la última página',
  goToNextPage: 'Ir a la página siguiente',
  goToPreviousPage: 'Ir a la página anterior',
  max: 'Máx',
  min: 'Mín',
  minGreaterThanMax: 'El mínimo no puede ser mayor que el máximo',
  noResultsFound: 'No se encontraron resultados',
  of: 'de',
  page: 'Página',
  rowsPerPage: 'Filas por página',
  searchIn: 'Buscar en {column}',
  searchPlaceholder: 'Buscar...',
  selectStatus: 'Seleccionar estado',
  showAll: 'Mostrar todas',
  textAdvanced: {
    addCondition: 'Agregar condición',
    removeCondition: 'Quitar condición',
    placeholder: 'Valor…',
    invalidRegex: 'Patrón regex inválido',
  },
  textOperator: {
    contains: 'contiene',
    notContains: 'no contiene',
    regex: 'regex',
    notRegex: 'no regex',
    equals: 'es exactamente',
    notEquals: 'no es',
    oneOf: 'es una de',
  },
  to: 'Hasta',
  toggleColumns: 'Alternar columnas',
} as const
